var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
// @ts-ignore
import svg from './arrow.svg';
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: fit-content;\n  height: 30px;\n  opacity: 0.2;\n  transition: opacity 0.2s ease-in;\n  cursor: pointer;\n  \n  :hover {\n    opacity: 1;\n  }\n"], ["\n  width: fit-content;\n  height: 30px;\n  opacity: 0.2;\n  transition: opacity 0.2s ease-in;\n  cursor: pointer;\n  \n  :hover {\n    opacity: 1;\n  }\n"])));
export var ArrowSvg = styled.img.attrs({
    src: svg,
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 100%;\n  ", "\n"], ["\n  height: 100%;\n  ", "\n"])), function (_a) {
    var type = _a.type;
    return type === 'right' && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["transform: rotate(180deg);"], ["transform: rotate(180deg);"])));
});
var templateObject_1, templateObject_2, templateObject_3;
